import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, CheckIcon, LockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BrandMark } from '../components/BrandMark';
import { COMPANY, LEGAL_LINKS, OFFER } from '../data/company';
import { PAYPAL_PAYMENT_URL, formatPrice } from '../utils/payments';
export function CheckoutPage() {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleBlockedClick = (event: React.MouseEvent) => {
    if (acceptedTerms) return;
    event.preventDefault();
    setShowTermsError(true);
  };
  return <div className="min-h-screen bg-black px-5 py-8 pb-28 sm:px-8 sm:py-14 sm:pb-32" data-id="element-205" data-mp="b2jmd6ufuyhu">
      <div className="mx-auto w-full max-w-5xl" data-id="element-206" data-mp="1iea91k6msgo0">
        <div className="mb-6 flex items-center justify-between" data-id="element-207" data-mp="1ihoc6un4ctwi">
          <Link to="/" className="inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.18em] text-neutral-300 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-208" data-mp="1mfm5a8k0g056">
            <ArrowLeftIcon size={14} aria-hidden="true" data-id="element-209" data-mp="truvv6yeayzr" />
            Volver
          </Link>
          <span className="inline-flex items-center gap-2.5 text-white" data-id="element-210" data-mp="prkg52kswu7p">
            <BrandMark size={17} data-id="element-211" data-mp="kry0ynlex3w9" />
            <span className="text-[12px] font-semibold tracking-[0.16em]" data-id="element-212" data-mp="ks7q68ymv70w">
              {COMPANY.brand}
            </span>
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-2 border-white bg-white" data-id="element-213" data-mp="fzendqmq68rg">
          <div className="bg-black px-6 py-5 sm:px-9 sm:py-6" data-id="element-214" data-mp="3t8swtj3slo0u">
            <h1 className="text-2xl font-medium tracking-[-0.03em] text-white sm:text-3xl" data-id="element-215" data-mp="3jkdshrv9mbg2">
              Revisa y confirma tu pedido
            </h1>
          </div>

          <div className="grid lg:grid-cols-[1.15fr_0.85fr]" data-id="element-216" data-mp="3njmkosanq19i">
            {/* ---------------- Servicio y condiciones ---------------- */}
            <div className="px-6 py-8 sm:px-9 sm:py-10" data-id="element-217" data-mp="3ekj0fkzr7ftf">
              <h2 className="text-lg font-medium tracking-[-0.02em] text-black" data-id="element-218" data-mp="3en57ljiqftb4">
                {OFFER.name}
              </h2>
              <p className="mt-2 text-[13px] leading-relaxed text-neutral-600" data-id="element-219" data-mp="b42iup9kj1vb">
                {OFFER.summary}. Diseñamos y ponemos en marcha la presencia
                digital de tu negocio, y nos ocupamos después de su gestión y
                mantenimiento.
              </p>

              <ul className="mt-6 space-y-3 border-t border-black/15 pt-6" data-id="element-220" data-mp="1c67wdmdvh9o">
                {OFFER.included.map(item => <li key={item} className="flex gap-3 text-[13px] leading-relaxed text-neutral-700" data-id="element-221" data-mp="tvbub42wg0pj">
                    <CheckIcon size={15} className="mt-0.5 shrink-0 text-black" aria-hidden="true" data-id="element-222" data-mp="2ej4f29k0iasm" />
                    {item}
                  </li>)}
              </ul>

              <h3 className="mt-10 text-lg font-medium tracking-[-0.02em] text-black" data-id="element-223" data-mp="2jch4glwimlmf">
                Condiciones de la compra
              </h3>
              <dl className="mt-5 border-t border-black/15" data-id="element-224" data-mp="1qn9xqzmwqpq3">
                {[['Precio', `${formatPrice(OFFER.price)} (EUR)`], ['Forma de pago', 'Pago único'], ['Impuestos', 'Según país de facturación'], ['Entrega estimada', '2 a 4 semanas'], ['Cancelación', 'Reembolso íntegro antes de iniciar los trabajos']].map(([label, value]) => <div key={label} className="flex items-start justify-between gap-4 border-b border-black/15 py-3.5" data-id="element-225" data-mp="a8fglqsyt8et">
                    <dt className="text-[13px] text-neutral-600" data-id="element-226" data-mp="k63c4iyeajy1">{label}</dt>
                    <dd className="text-right text-[13px] font-medium text-black" data-id="element-227" data-mp="k4sb2qwc3qam">
                      {value}
                    </dd>
                  </div>)}
              </dl>
              <p className="mt-4 text-[12px] leading-relaxed text-neutral-600" data-id="element-228" data-mp="t6i0xsakih6a">
                {OFFER.taxNotice} El plazo de entrega comienza cuando
                disponemos de la información y los materiales necesarios.
              </p>

              <div className="mt-7 border border-black/20 p-5" data-id="element-229" data-mp="17w7ekmzukdng">
                <label className="flex cursor-pointer items-start gap-3" data-id="element-230" data-mp="17xqta95uugn4">
                  <input type="checkbox" checked={acceptedTerms} onChange={event => {
                  setAcceptedTerms(event.target.checked);
                  if (event.target.checked) setShowTermsError(false);
                }} className="mt-0.5 h-4 w-4 shrink-0 accent-black focus:outline-none focus-visible:ring-2 focus-visible:ring-black" data-id="element-231" data-mp="1cwbx0ikbfigb" />
                  <span className="text-[13px] leading-relaxed text-neutral-700" data-id="element-232" data-mp="2nf5b9vyduyn3">
                    He leído y acepto los{' '}
                    <Link to="/terminos" target="_blank" className="font-medium text-black underline underline-offset-2 hover:no-underline" data-id="element-233" data-mp="3l12phh5qcht8">
                      Términos y condiciones
                    </Link>
                    , la{' '}
                    <Link to="/privacidad" target="_blank" className="font-medium text-black underline underline-offset-2 hover:no-underline" data-id="element-234" data-mp="36bdj97is5nm3">
                      Política de privacidad
                    </Link>{' '}
                    y la{' '}
                    <Link to="/reembolsos" target="_blank" className="font-medium text-black underline underline-offset-2 hover:no-underline" data-id="element-235" data-mp="216q5emifbntu">
                      Política de reembolsos
                    </Link>
                    .
                  </span>
                </label>
                {showTermsError && !acceptedTerms && <p role="alert" className="mt-3 text-[12px] text-red-600" data-id="element-236" data-mp="1igi7citkznki">
                    Debes aceptar las condiciones para continuar.
                  </p>}
              </div>
            </div>

            {/* ---------------- Resumen ---------------- */}
            <aside className="border-t-2 border-black/15 px-6 py-8 sm:px-9 sm:py-10 lg:border-l-2 lg:border-t-0" data-id="element-237" data-mp="2ytp75bnz3lyl">
              <h2 className="text-lg font-medium tracking-[-0.02em] text-black" data-id="element-238" data-mp="33rqnvpxxf96w">
                Resumen del pedido
              </h2>
              <div className="mt-6 flex items-start justify-between gap-4 border-b border-black/15 pb-4" data-id="element-239" data-mp="3duw1inxlzqlp">
                <p className="text-[14px] leading-relaxed text-black" data-id="element-240" data-mp="38w2loouunnid">
                  {OFFER.name}
                  <span className="mt-1 block text-[13px] text-neutral-600" data-id="element-241" data-mp="3mr4vhn2thx0g">
                    {OFFER.summary}
                  </span>
                </p>
                <p className="shrink-0 text-[14px] font-medium tabular-nums text-black" data-id="element-242" data-mp="gsjzhuvgkb4">
                  {formatPrice(OFFER.price)}
                </p>
              </div>
              <div className="flex items-center justify-between gap-4 border-b border-black/15 py-4" data-id="element-243" data-mp="9j1w2c5sglqm">
                <p className="text-[13px] text-neutral-600" data-id="element-244" data-mp="5gx6boigo999">Impuestos</p>
                <p className="text-right text-[13px] text-neutral-700" data-id="element-245" data-mp="2ba54qvw4bq8j">
                  Según país de facturación
                </p>
              </div>
              <div className="flex items-baseline justify-between gap-4 py-5" data-id="element-246" data-mp="27a4joseikgsi">
                <p className="text-[15px] font-medium text-black" data-id="element-247" data-mp="2vsf7575e1jiv">
                  Total (EUR)
                </p>
                <p className="text-2xl font-medium tabular-nums tracking-[-0.03em] text-black" data-id="element-248" data-mp="30r05f112xt4o">
                  {formatPrice(OFFER.price)}
                </p>
              </div>

              <a href={PAYPAL_PAYMENT_URL} target="_blank" rel="noopener noreferrer" onClick={handleBlockedClick} aria-disabled={!acceptedTerms} className={`flex h-[52px] w-full items-center justify-center gap-2 px-5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-white ${acceptedTerms ? 'bg-black text-white hover:bg-neutral-800' : 'cursor-not-allowed bg-neutral-300 text-neutral-600'}`} data-id="element-249" data-mp="39jtprcvdvipe">
                <LockIcon size={15} aria-hidden="true" data-id="element-250" data-mp="g8crxnbht9q4" />
                Continuar al pago seguro
              </a>
              <p className="mt-3 text-center text-[12px] text-neutral-600" data-id="element-251" data-mp="bab9n4lw5efp">
                Pago seguro procesado por PayPal
              </p>

              <p className="mt-5 text-[12px] leading-relaxed text-neutral-600" data-id="element-252" data-mp="6fxacr43yn5r">
                Completarás el pago en el entorno seguro de PayPal. Growthly no
                procesa ni almacena los datos de tu método de pago.
              </p>

              <div className="mt-7 border-t border-black/15 pt-6" data-id="element-253" data-mp="3omv3hz0n77eh">
                <p className="text-[12px] font-medium text-black" data-id="element-254" data-mp="3jojt9n6fquvq">
                  ¿Dudas antes de comprar?
                </p>
                <a href={`mailto:${COMPANY.supportEmail}`} className="mt-2 block text-[13px] text-neutral-700 underline underline-offset-4 hover:text-black" data-id="element-255" data-mp="3fo9oueyakciz">
                  {COMPANY.supportEmail}
                </a>
                <a href={COMPANY.whatsappUrl} target="_blank" rel="noopener noreferrer" className="mt-1.5 block text-[13px] text-neutral-700 underline underline-offset-4 hover:text-black" data-id="element-256" data-mp="17wgvdfocw5q6">
                  {COMPANY.phone}
                </a>
              </div>
            </aside>
          </div>
        </motion.div>

        <nav aria-label="Información legal" className="mt-6" data-id="element-257" data-mp="p5pockrucrey">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-258" data-mp="p462menf1o5s">
            {LEGAL_LINKS.map(link => <li key={link.href} data-id="element-259" data-mp="ywka7o16dozv">
                <Link to={link.href} className="text-[12px] text-neutral-300 underline underline-offset-4 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-260" data-mp="ywu1dexyi275">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>
    </div>;
}